// import { get, set, del } from 'idb-keyval';
//
// export const indexedDBStorage = (key: string) => ({
// 	name: key,
// 	getItem: async (name: string) => {
// 		const value = await get(name);
// 		return value ? JSON.stringify(value) : null;
// 	},
// 	setItem: async (name: string, value: string) => {
// 		await set(name, JSON.parse(value));
// 	},
// 	removeItem: async (name: string) => {
// 		await del(name);
// 	},
// });

import appConfig from "config/appConfig";
import { openDB } from "idb";

const DB_NAME = appConfig.INDEX_DB_NAME;
const DB_VERSION = appConfig.INDEX_DB_VERSION;
const STORE_NAME = appConfig.INDEX_DB_STORE_NAME;

const dbPromise = openDB(DB_NAME, DB_VERSION, {
	upgrade(db) {
		if (!db.objectStoreNames.contains(STORE_NAME)) {
			db.createObjectStore(STORE_NAME);
		}
	}
});

export const createIndexedDBStorage = (keyPrefix: string) => ({
	name: keyPrefix,
	getItem: async (name: string) => {
		const db = await dbPromise;
		const result = await db.get(STORE_NAME, `${keyPrefix}:${name}`);
		return result ? JSON.parse(result) : null;
	},
	setItem: async (name: string, value: string) => {
		const db = await dbPromise;
		await db.put(STORE_NAME, JSON.stringify(value), `${keyPrefix}:${name}`);
	},
	removeItem: async (name: string) => {
		const db = await dbPromise;
		await db.delete(STORE_NAME, `${keyPrefix}:${name}`);
	}
});
